module.exports = ".centrarBotones {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\nimg {\n  border: 0;\n  width: 420px; }\n\n.slideshow-container {\n  height: 420px !important;\n  width: 420px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/modals/modal-image-slider-dialog.component.scss
// module id = ./src/app/shared-components/modals/modal-image-slider-dialog.component.scss
// module chunks = main